import { API_APPLICATION, AUTH_BEARER, AUTH_SESSION } from "../constants";
import { axiosDelete, axiosGet, axiosPost, axiosPut, getAuthorization } from "../utils/axios";

const ApplicationApi = {

  getApps: async (paginationParams: any) => {

    const headers = {
      ...getAuthorization(AUTH_SESSION),
    };

    return await axiosGet(API_APPLICATION, { ...paginationParams }, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error getApps:", error);
        return error.response.data;
      });
  },

  getApp: async (appId: string) => {
    const headers = {
      ...getAuthorization(AUTH_SESSION),
    };

    return await axiosGet(`${API_APPLICATION}/${appId}`, {}, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error getApp:", error);
        return error.response.data;
      });
  },

  createApp: async (name: string, description: string, website: string, redirectURIs: string[]) => {
    const headers = {
      ...getAuthorization(AUTH_SESSION),
    };

    return await axiosPost(API_APPLICATION, { 'name': name, 'description': description, 'website': website, 'redirectURIs': redirectURIs }, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error createApp:", error);
        return error.response.data;
      });
  },

  deleteApp: async (appId: string) => {
    const headers = {
      ...getAuthorization(AUTH_SESSION),
    };

    return await axiosDelete(`${API_APPLICATION}/${appId}`, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error deleteApp:", error);
        return error.response.data;
      });
  },

  createRedirectUri: async (appId: string, redirectURI: string) => {

    const headers = {
      ...getAuthorization(AUTH_SESSION),
    };

    return await axiosPost(`${API_APPLICATION}/${appId}/redirect-uris`, { 'redirectURI': redirectURI }, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error createRedirectUri:", error);
        return error.response.data;
      });
  },

  deleteRedirectUri: async (appId: string, redirectURIId: string) => {

    const headers = {
      ...getAuthorization(AUTH_SESSION),
    };

    return await axiosDelete(`${API_APPLICATION}/${appId}/redirect-uris/${redirectURIId}`, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error deleteRedirectUri:", error);
        return error.response.data;
      });
  },

  setProjectAccess: async (appId: string, projectIds: string[]) => {
    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosPut(`${API_APPLICATION}/${appId}/projects/access`, { 'projectIds': projectIds }, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error setProjectAccess:", error);
        return error.response.data;
      });
  },

  addProjectAccess: async (appId: string, projectId: string) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosPost(`${API_APPLICATION}/${appId}/projects/${projectId}/access`, {}, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error addProjectAccess:", error);
        return error.response.data;
      });
  },

  deleteProjectAccess: async (appId: string, projectId: string) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosDelete(`${API_APPLICATION}/${appId}/projects/${projectId}/access`, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error deleteProjectAccess:", error);
        return error.response.data;
      });
  },

  getApiKeys: async (appId: string) => {

    const headers = {
      ...getAuthorization(AUTH_SESSION),
    };

    return await axiosGet(`${API_APPLICATION}/${appId}/api-keys`, {}, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error getApiKeys:", error);
        return error.response.data;
      });
  },

  createApiKey: async (appId: string) => {

    const headers = {
      ...getAuthorization(AUTH_SESSION),
    };

    return await axiosPost(`${API_APPLICATION}/${appId}/api-keys`, {}, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error createApiKey:", error);
        return error.response.data;
      });
  },

  revokeApiKey: async (appId: string, apiKeyId: string) => {

    const headers = {
      ...getAuthorization(AUTH_SESSION),
    };

    return await axiosDelete(`${API_APPLICATION}/${appId}/api-keys/${apiKeyId}`, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error revokeApiKey:", error);
        return error.response.data;
      });
  },
};

export default ApplicationApi;
